import { render, staticRenderFns } from "./GameText.vue?vue&type=template&id=cf5e1880&scoped=true"
import script from "./GameText.vue?vue&type=script&lang=js"
export * from "./GameText.vue?vue&type=script&lang=js"
import style0 from "./GameText.vue?vue&type=style&index=0&id=cf5e1880&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5e1880",
  null
  
)

export default component.exports